/**
 * Mix & Match Combo
 * Handles Color + Size selection per product and adds both chosen
 * variants to the Shopify cart together via the Ajax Cart API.
 */
window.MixMatchCombo = (function () {
  // Fallback hex values for common apparel color names that aren't valid CSS keywords.
  var COLOR_FALLBACKS = {
    'peach': '#ffcba4',
    'mauve': '#b784a7',
    'olive': '#808000',
    'blush': '#de5d83',
    'rust': '#b7410e',
    'wine': '#722f37',
    'sand': '#c2b280',
    'stone': '#928e85',
    'charcoal': '#36454f',
    'ivory': '#fffff0',
    'cream': '#fffdd0',
    'khaki': '#c3b091',
    'burgundy': '#800020',
    'coral': '#ff7f50',
    'teal': '#008080',
    'mint': '#98ff98',
    'lilac': '#c8a2c8',
    'lavender': '#e6e6fa',
    'plum': '#8e4585',
    'sage': '#9caf88',
    'taupe': '#483c32',
    'camel': '#c19a6b',
    'mustard': '#ffdb58',
    'apricot': '#fbceb1',
    'salmon': '#fa8072',
    'denim': '#1560bd',
    'slate': '#708090',
    'cobalt': '#0047ab',
    'emerald': '#50c878',
    'jade': '#00a86b',
    'copper': '#b87333',
    'bronze': '#cd7f32',
    'champagne': '#f7e7ce'
  };

  // Returns a CSS-usable color value for any swatch name, even non-standard ones.
  function resolveColor(name) {
    if (!name) return '#ccc';
    var key = name.trim().toLowerCase();

    // exact fallback match
    if (COLOR_FALLBACKS[key]) return COLOR_FALLBACKS[key];

    // partial match, e.g. "Dusty Mauve" -> mauve
    for (var k in COLOR_FALLBACKS) {
      if (key.indexOf(k) !== -1) return COLOR_FALLBACKS[k];
    }

    // test if the browser understands it as a real CSS color (e.g. "Navy", "Black")
    var probe = document.createElement('span');
    probe.style.color = '';
    probe.style.color = key;
    if (probe.style.color !== '') return key;

    // last resort: neutral gray so it's at least visible, not invisible
    return '#cccccc';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  // Find the option index (0/1/2) whose name matches (case-insensitive)
  function findOptionIndex(optionsWithValues, name) {
    for (var i = 0; i < optionsWithValues.length; i++) {
      if (optionsWithValues[i].name.toLowerCase() === name.toLowerCase()) {
        return i; // 0-based, matches variant.options[i]
      }
    }
    return -1;
  }

  function matchVariant(variants, colorIdx, sizeIdx, color, size) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var vColor = colorIdx > -1 ? v.options[colorIdx] : null;
      var vSize = sizeIdx > -1 ? v.options[sizeIdx] : null;
      var colorOk = colorIdx === -1 || vColor === color;
      var sizeOk = sizeIdx === -1 || vSize === size;
      if (colorOk && sizeOk) return v;
    }
    return null;
  }

  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;
    if (root.dataset.mmInitialized === 'true') return;
    root.dataset.mmInitialized = 'true';

    var discountPercent = parseFloat(root.dataset.discountPercent) || 0;

    var productBlocks = root.querySelectorAll('.mm-combo__product');
    var addBtn = root.querySelector('[data-role="add-combo-btn"]');
    var totalEl = root.querySelector('[data-role="combo-total"]');
    var originalTotalEl = root.querySelector('[data-role="combo-original-total"]');
    var discountNoteEl = root.querySelector('[data-role="combo-discount-note"]');
    var errorEl = root.querySelector('[data-role="combo-error"]');
    var successEl = root.querySelector('[data-role="combo-success"]');

    // selections[index] = { variantId, priceCents, available }
    var selections = {};

    productBlocks.forEach(function (block, idx) {
      var variantDataEl = block.querySelector('[data-role="variant-data"]');
      var optionDataEl = block.querySelector('[data-role="option-data"]');
      var variants = JSON.parse(variantDataEl.textContent);
      var optionsWithValues = JSON.parse(optionDataEl.textContent);

      var colorIdx = findOptionIndex(optionsWithValues, 'Color');
      var sizeIdx = findOptionIndex(optionsWithValues, 'Size');

      var colorButtons = block.querySelectorAll('[data-role="color-group"] .mm-swatch');
      var sizeButtons = block.querySelectorAll('[data-role="size-group"] .mm-size');
      var priceEl = block.querySelector('[data-role="product-price"]');
      var summaryEl = block.querySelector('[data-role="selected-summary"]');
      var unavailableEl = block.querySelector('[data-role="unavailable-msg"]');

      // --- Carousel setup ---
      var carouselEl = block.querySelector('[data-role="carousel"]');
      var trackEl = block.querySelector('[data-role="carousel-track"]');
      var slideEls = trackEl ? Array.prototype.slice.call(trackEl.querySelectorAll('.mm-combo__carousel-image')) : [];
      var prevBtn = block.querySelector('[data-role="carousel-prev"]');
      var nextBtn = block.querySelector('[data-role="carousel-next"]');
      var dotEls = block.querySelectorAll('[data-role="carousel-dots"] .mm-combo__carousel-dot');
      var currentSlide = 0;

      function goToSlide(index) {
        if (!trackEl || !slideEls.length) return;
        currentSlide = Math.max(0, Math.min(index, slideEls.length - 1));
        trackEl.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
        dotEls.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === currentSlide);
        });
      }

      function slideIndexForImageId(imageId) {
        for (var i = 0; i < slideEls.length; i++) {
          if (slideEls[i].dataset.imageId === String(imageId)) return i;
        }
        return -1;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentSlide === 0 ? slideEls.length - 1 : currentSlide - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentSlide === slideEls.length - 1 ? 0 : currentSlide + 1);
        });
      }
      dotEls.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goToSlide(i); });
      });
      // --- End carousel setup ---

      // Paint each swatch with a real, visible color
      colorButtons.forEach(function (btn) {
        var inner = btn.querySelector('.mm-swatch__swatch-inner');
        var resolved = resolveColor(btn.dataset.color);
        if (inner) inner.style.backgroundColor = resolved;
      });

      var state = {
        color: colorButtons.length ? colorButtons[0].dataset.color : null,
        size: sizeButtons.length ? sizeButtons[0].dataset.size : null
      };

      function refresh() {
        var variant = matchVariant(variants, colorIdx, sizeIdx, state.color, state.size);

        if (!variant) {
          unavailableEl.hidden = false;
          summaryEl.textContent = '';
          delete selections[idx];
          updateSummary();
          return;
        }

        unavailableEl.hidden = variant.available;
        var parts = [];
        if (state.color) parts.push(state.color);
        if (state.size) parts.push(state.size);
        summaryEl.textContent = 'Selected: ' + parts.join(' / ');
        priceEl.textContent = formatMoney(variant.price);

        if (variant.featured_image && variant.featured_image.id) {
          var slideIdx = slideIndexForImageId(variant.featured_image.id);
          if (slideIdx > -1) goToSlide(slideIdx);
        }

        if (variant.available) {
          selections[idx] = { variantId: variant.id, priceCents: variant.price };
        } else {
          delete selections[idx];
        }
        updateSummary();
      }

      colorButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          colorButtons.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          state.color = btn.dataset.color;
          refresh();
        });
      });

      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          state.size = btn.dataset.size;
          refresh();
        });
      });

      refresh();
    });

    function updateSummary() {
      var keys = Object.keys(selections);
      if (keys.length < productBlocks.length) {
        totalEl.textContent = '—';
        originalTotalEl.textContent = '';
        discountNoteEl.hidden = true;
        addBtn.disabled = true;
        return;
      }
      var subtotal = keys.reduce(function (sum, k) { return sum + selections[k].priceCents; }, 0);

      if (discountPercent > 0) {
        var discounted = Math.round(subtotal * (1 - discountPercent / 100));
        originalTotalEl.textContent = formatMoney(subtotal);
        totalEl.textContent = formatMoney(discounted);
        discountNoteEl.textContent = '🎉 ' + discountPercent + '% combo discount applied';
        discountNoteEl.hidden = false;
      } else {
        originalTotalEl.textContent = '';
        totalEl.textContent = formatMoney(subtotal);
        discountNoteEl.hidden = true;
      }

      addBtn.disabled = false;
    }

    addBtn.addEventListener('click', function () {
      errorEl.hidden = true;
      successEl.hidden = true;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      var items = Object.keys(selections).map(function (k) {
        return { id: selections[k].variantId, quantity: 1 };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          addBtn.textContent = 'Added! Refreshing...';
          // Reload so the cart icon/drawer reflects the new items reliably,
          // regardless of how this theme's cart UI is implemented internally.
          window.location.reload();
        })
        .catch(function (err) {
          console.error(err);
          errorEl.textContent = 'Something went wrong adding the combo to your cart. Please try again.';
          errorEl.hidden = false;
          addBtn.textContent = 'Add Combo to Cart';
          addBtn.disabled = false;
        });
    });
  }

  return { init: init };
})();
